module.exports = __webpack_public_path__ + "static/media/Nunito-Black.76e62b37.ttf";